import React from 'react';
import { ChevronRightIcon, ClockIcon, MapPinIcon, SparklesIcon } from 'lucide-react';
import { followUps, registrations } from '../../data/loisirs';
export function MyActivities() {
  return <section aria-labelledby="mes-activites-titre" className="mt-14" data-id="element-1634" data-mp="16v2i4saygsz4">
      <h2 id="mes-activites-titre" className="text-2xl font-extrabold tracking-tight text-ville-navy" data-id="element-1635" data-mp="16wx3u8u1wp49">
        Mes activités
      </h2>
      <p className="mt-1 text-[15px] text-slate-600" data-id="element-1636" data-mp="x4hn1euhq6ky">Vos inscriptions et celles de votre famille.</p>

      <div className="mt-6 grid gap-5 lg:grid-cols-[minmax(0,1fr)_minmax(0,340px)] lg:gap-8" data-id="element-1637" data-mp="11vpvo8nzxnx2">
        <ul className="space-y-3" data-id="element-1638" data-mp="o4ukgpq0yuqb">
          {registrations.map(registration => <li key={registration.id} data-id="element-1639" data-mp="t2wc3z1io2de">
              <button type="button" className="group flex w-full items-center gap-4 rounded-2xl border border-slate-200 bg-white px-5 py-4 text-left transition-colors duration-150 ease-ville hover:border-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-1640" data-mp="t3xoc6u9quwp">
                <span className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-slate-100 text-sm font-bold text-ville-navy" aria-hidden="true" data-id="element-1641" data-mp="3kei4rje21kll">
                  {registration.initials}
                </span>
                <span className="min-w-0 flex-1" data-id="element-1642" data-mp="3pcjnu4bhdjx2">
                  <span className="flex flex-wrap items-center gap-2" data-id="element-1643" data-mp="31lo2nq1j5mys">
                    <span className="font-bold text-ville-navy" data-id="element-1644" data-mp="2wn30vm6mqv88">{registration.activity}</span>
                    <span className="rounded-full bg-ville-indigo-soft px-2.5 py-0.5 text-xs font-bold text-ville-indigo" data-id="element-1645" data-mp="2wl9tg4o706z6">
                      {registration.participant} · inscrite
                    </span>
                  </span>
                  <span className="mt-1 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm text-slate-500" data-id="element-1646" data-mp="2hxeysiqmjsjg">
                    <span className="flex items-center gap-1.5" data-id="element-1647" data-mp="2dvjzfjs97p8b">
                      <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-1648" data-mp="gvz1t4k95nx0" />
                      {registration.schedule}
                    </span>
                    <span className="flex items-center gap-1.5" data-id="element-1649" data-mp="ltr0qijbeaap">
                      <MapPinIcon className="h-4 w-4" aria-hidden="true" data-id="element-1650" data-mp="ql8rkdrmiuhy" />
                      {registration.place}
                    </span>
                  </span>
                  <span className="mt-1 block text-sm font-semibold text-ville-navy" data-id="element-1651" data-mp="vmpqw4ugm8wf">{registration.nextSession}</span>
                </span>
                <ChevronRightIcon className="h-5 w-5 shrink-0 text-slate-400 transition-colors duration-150 ease-ville group-hover:text-ville-indigo" aria-hidden="true" data-id="element-1652" data-mp="2vefvzj1jbza" />
              </button>
            </li>)}
        </ul>

        <aside aria-label="Suivis d’ATNA" className="rounded-2xl border border-slate-200 bg-slate-50 p-5" data-id="element-1653" data-mp="1japonoq6uzki">
          <p className="flex items-center gap-2 text-sm font-bold text-ville-indigo" data-id="element-1654" data-mp="1o90yw0kebc39">
            <SparklesIcon className="h-4 w-4" aria-hidden="true" data-id="element-1655" data-mp="38rbjlxljha72" />
            Suivis d’ATNA
          </p>
          <ul className="mt-3 space-y-3" data-id="element-1656" data-mp="33rynem8s2qrt">
            {followUps.map(item => <li key={item} className="rounded-xl bg-white px-4 py-3 text-sm leading-relaxed text-slate-600" data-id="element-1657" data-mp="2z1rxmj2j507z">
                {item}
              </li>)}
          </ul>
        </aside>
      </div>
    </section>;
}